import { useState, useEffect } from 'react';
import { getOrderStatusCounts } from '../services/orderService';

interface OrderStatusCounts {
  delivered: number;
  shipped: number;
  cancelled: number;
  processing: number;
  processed: number;
}

interface UseOrderStatusResult {
  data: OrderStatusCounts;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export const useOrderStatus = (): UseOrderStatusResult => {
  const [data, setData] = useState<OrderStatusCounts>({
    delivered: 0,
    shipped: 0,
    cancelled: 0,
    processing: 0,
    processed: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const statusCounts = await getOrderStatusCounts();
      setData(statusCounts);
    } catch (err) {
      console.error('Error fetching order status counts:', err);
      setError('Failed to load order status data');
      setData({
        delivered: 0,
        shipped: 0,
        cancelled: 0,
        processing: 0,
        processed: 0
      });
    } finally {
      setLoading(false);
    }
  };

  const refresh = async () => {
    await fetchData();
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    loading,
    error,
    refresh
  };
}; 
